package com.arena_web.domain.usecases.auth

import com.arena_web.data.dto.AuthResponse
import com.arena_web.data.dto.LoginRequest
import com.arena_web.domain.repositories.AuthRepository

class LoginUseCase(private val authRepository: AuthRepository) {

    suspend operator fun invoke(username: String, password: String): Result<AuthResponse> {
        val result = authRepository.login(LoginRequest(username, password))
        result.onSuccess { saveAuthSession(it) }
        return result
    }
}
